// Subcategory labels a product belongs to (multi-model support).
// Falls back to the legacy single "subcategory" label when the API
// does not provide a "subcategories" array.
export const productSubcategories = (p) => {
    if (Array.isArray(p?.subcategories) && p.subcategories.length > 0) {
        return p.subcategories;
    }
    if (p?.subcategory) {
        return [p.subcategory];
    }
    return [];
};
